import { render, staticRenderFns } from "./OrderInfoPayment.vue?vue&type=template&id=54731ae8&"
import script from "./OrderInfoPayment.vue?vue&type=script&lang=js&"
export * from "./OrderInfoPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports